import React, {useState, useEffect} from 'react';
import {withRouter, Switch, Route, Link} from 'react-router-dom';
import {Grid, Row, Col} from "react-flexbox-grid";
import './Tasks.css';
import ProjectTaskContainer from "./ProjectTaskContainer";
import {spinnerOff, spinnerOn} from "../../../components/Spinner";
import {getProjectTasksByProjectId} from "../../../api";
import TasksContainer from "./container";



function ProjectTasks({location, project, status}) {

        return (
            <Grid fluid>
                <Row>
                    <Switch location={location}>
                        <Route
                            exact
                            key="list"
                            path={`/:status/:projectId/projecttasks`}
                            component={() =>
                                <ProjectTaskContainer project={project}
                                                      status={status}
                                />
                            }
                        />
                        <Route
                            exact
                            key={"checklist"}
                            path={`/:status/:projectId/projecttasks/:checklist`}
                            component={() =>
                                <TasksContainer project={project}
                                                status={status}
                                />
                            }
                        />
                    </Switch>
                </Row>
                <br/>
            </Grid>
        );
}

export default withRouter(ProjectTasks);
